import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
// import ViewIcon from '@material-ui/icons/RemoveRedEye';
// import EditIcon from '@material-ui/icons/Edit';
import Button from "@material-ui/core/Button";
import { CircularProgress } from "components/UI/Progress";
import get from "lodash/get";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 700,
  },
  button: {
    margin: 2,
    padding: 2,
  },
  input: {
    display: "none",
  },
});

class IndexTable extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 10,
  };

  handleShowAction = id => e => {
    e.preventDefault();
    const { history, match } = this.props;
    history.push(`${match.url}/${id}/show`);
  };

  handleEditAction = id => e => {
    e.preventDefault();
    const { history, match } = this.props;
    history.push(`${match.url}/${id}/edit`);
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render() {
    const { classes, headers, rows, actions, isLoading } = this.props;

    const { page, rowsPerPage } = this.state;

    if (!rows) return <div>Loading..</div>;

    const pageRows = rows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    return (
      <Paper className={classes.root} elevation={0}>
        {isLoading && <CircularProgress />}

        {!isLoading && (
          <React.Fragment>
            <Table className={classes.table} padding="dense">
              <TableHead>
                <TableRow>
                  {headers &&
                    headers.map(header => (
                      <TableCell key={header.key}>{header.alias}</TableCell>
                    ))}
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pageRows ? (
                  pageRows.map(row => (
                    <TableRow key={row.id}>
                      {headers &&
                        headers.map(header => (
                          <TableCell key={header.key}>
                            {get(row, header.key)}
                          </TableCell>
                        ))}

                      <TableCell align="right">
                        {actions && actions.view && (
                          <Button
                            variant="outlined"
                            color="primary"
                            className={classes.button}
                            onClick={this.handleShowAction(row.id)}
                          >
                            View
                          </Button>
                        )}

                        {actions && actions.edit && (
                          <Button
                            variant="outlined"
                            color="secondary"
                            className={classes.button}
                            onClick={this.handleEditAction(row.id)}
                          >
                            Edit
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableCell colSpan={headers.length + 1}>
                    No data available
                  </TableCell>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </React.Fragment>
        )}
      </Paper>
    );
  }
}

IndexTable.defaultProps = {
  headers: [],
  rows: [],
  actions: {
    edit: true,
    view: true,
  },
};

IndexTable.propTypes = {
  classes: PropTypes.object.isRequired,
  headers: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  moduleName: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    edit: PropTypes.bool,
    view: PropTypes.bool,
  }),
};

export default compose(
  withStyles(styles),
  withRouter
)(IndexTable);
